import Image from "next/image";
import { Typography } from "@/components/ui/typography";
import { formatNumber } from "@/utils/format/formatNumber";
import { PopularDestination } from "@/types/popular-destination";

interface DestinationCardProps {
  destination: PopularDestination;
}

export const DestinationCard = ({ destination }: DestinationCardProps) => {
  // Handle missing fields with "-"
  const title = destination.cityName || "-";
  const thumbnail = destination.thumbnail || destination.icon || "/images/placeholder.png";
  const average = destination.average ?? 0;
  const displayAverage = average > 0 ? formatNumber(average) : "-";

  return (
    <div className="flex items-center gap-3 border rounded-[8px] md:rounded-[12px] p-2 md:p-3 border-gray-100 cursor-pointer hover:border-gray-200 transition-colors">
      <div className="relative w-16 md:w-[72px] aspect-[1.1/1] rounded-[13px] overflow-hidden shrink-0">
        <Image
          src={thumbnail}
          alt={title}
          fill
          sizes="(max-width: 768px) 64px, 72px"
          className="object-cover"
        />
      </div>
      <div className="flex flex-col items-start">
        <Typography variant="bodySMedium" className="md:text-base">
          {title}
        </Typography>
        <div className="mt-1 md:mt-0 flex flex-col md:flex-row md:gap-1">
          <Typography variant="captionSRegular" className="md:text-sm">
            میانگین
          </Typography>
          <Typography variant="captionRegular" className="md:text-sm">
            {displayAverage} {average > 0 ? "تومان" : ""}
          </Typography>
        </div>
      </div>
    </div>
  );
};

